import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Results from "../views/Results.vue";
import Goodbye from "../views/Goodbye.vue";
import About from "../views/About.vue";
import Nota from "../views/Nota.vue";
import Personal from "../views/Questions/Personal.vue";
import Confidential from "../views/Questions/Confidential.vue";
import Region from "../views/Questions/Region.vue";
import States from "../views/Questions/States.vue";
import Biometric from "../views/Questions/Biometric.vue";
import Software from "../views/Questions/Software.vue";
import Industry from "../views/Questions/Industry.vue";
import Defense from "../views/Questions/Defense.vue";
import Ownership from "../views/Questions/Ownership.vue";
import Children from "../views/Questions/Children.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/results",
    name: "Results",
    component: Results
  },
  {
    path: "/goodbye",
    name: "Goodbye",
    component: Goodbye
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/personal",
    name: "Personal",
    component: Personal
  },
  {
    path: "/confidential",
    name: "Confidential",
    component: Confidential
  },
  {
    path: "/region",
    name: "Region",
    component: Region
  },
  {
    path: "/states",
    name: "States",
    component: States
  },
  {
    path: "/biometric",
    name: "Biometric",
    component: Biometric
  },
  {
    path: "/software",
    name: "Software",
    component: Software
  },
  {
    path: "/industry",
    name: "Industry",
    component: Industry
  },
  {
    path: "/defense",
    name: "Defense",
    component: Defense
  },
  {
    path: "/ownership",
    name: "Ownership",
    component: Ownership
  },
  {
    path: "/children",
    name: "Children",
    component: Children
  },
  {
    path: "/nota",
    name: "Nota",
    component: Nota
  }
];

const router = new VueRouter({
  routes
});

export default router;
